import React, { useEffect } from 'react';
import { useData } from "../../../components/context/DataContext";

import Player from '../../../components/Video/Player';
import { useModal, useModalUpdate } from "../../context/ModalContext";

import { useVideoPlayer, useVideoPlayerUpdate } from "../../../components/context/VideoContext";

import './Slide.css';
import './Slide30.css';
import { Video_Safety } from '../../../assets/video';

const Slide30 = () => {

    // get/set json data
    const getData = useData();

    // get/set json data
    const getVideo = useVideoPlayer();
    const setVideo = useVideoPlayerUpdate();

    // Modal
    const popupModalSet = useModalUpdate();

    useEffect(() => {
        
    }, []);

    const openModal = (e) => {
        popupModalSet(true);
    }


    return (
        <div id="slide30">
        <div className="video-wrap">
        { <Player vid={Video_Safety} /> }
        </div>
        <div className="slide">
            <h1>{getData.talkingpaper[3].slides[0].title}</h1>
            <div className="slide-body-wrap">
            <div className="list-wrap">
                <div className="col-wrap">
                    <div className="col text-col fade">
                        <div className="top-rule"></div>
                        <div className="left-rule"></div>
                        <ul>
                            <li>ELUCIREM™ was shown to have a comparable safety profile to Gadovist<sup>®</sup></li>
                            <li>Overall, <span>18% of patients reported at least one adverse event</span> after MRI with ELUCIREM™ compared to 20% of patients after MRI with Gadovist<sup>®</sup></li>
                            <li>Most AEs were of <span>mild</span> intensity
                                <ul>
                                    <li>74% with ELUCIREM™ vs 77% with Gadovist<sup>®</sup></li>
                                </ul>
                            </li>
                            <li><span>4.2%</span> of patients reported <span>at least one treatment-emergent adverse event (TEAE)</span> related to contrast agent (vs 5.5% among Gadovist<sup>®</sup> patients)
                                <ul>
                                    <li>The most frequent TEAEs were <span>injection site</span> reactions</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        </div>
        </div>

    );
};

export default Slide30;